import ArrowBackRounded from "@mui/icons-material/ArrowBackRounded";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useNavigate, useOutletContext } from "react-router-dom";
import { storeRecommendationDashboardSideNavList } from "./data";
import Home from "./DashboardComponents/Home/Home";
import { useEffect, useState } from "react";
import { Breadcrumbs } from "@mui/material";
import { grey } from "@mui/material/colors";
import { StoreRecommendationState } from "context/StoreRecommendationContext";
import { rootProtectedPath, services } from "data/authData";

export const createSessionData = ({ email, session_type = "report", name = "" }) => {
	const data = {
		action: "session_create",
		user_id: email,
		session_type: session_type,
		name: name,
	};
	return data;
};

const StoreRecommendation = () => {
	const [currentPath, service] = useOutletContext();
	const { setService } = StoreRecommendationState();
	const [serviceDisplayname, setServiceDisplayName] = useState();

	const navigate = useNavigate();

	const tabComponents = {
		[storeRecommendationDashboardSideNavList.HOME.key]: {
			...storeRecommendationDashboardSideNavList.HOME,
			component: <Home />,
		},
	};
	useEffect(() => {
		setService(service);
		const url = window.location.pathname;
		setServiceDisplayName(
			url?.split(`/${rootProtectedPath}/${services.store_recommendation.path.split("/")[0]}/`)?.[1] ?? service.name,
		);
	}, [service]);

	return (
		<Box sx={{ width: "100%", height: "calc(100vh - 88px)", boxSizing: "border-box", overflow: "hidden" }}>
			<Box display="flex" alignItems="center" columnGap={1} sx={{ height: 48, flexShrink: 0 }}>
				<IconButton onClick={() => navigate(-1)}>
					<ArrowBackRounded />
				</IconButton>
				<Breadcrumbs>
					{serviceDisplayname
						?.split("/")
						.reduce((acc, row, i, arr) => {
							if (i !== arr.length - 1)
								acc.push(
									<Typography sx={{ color: grey[600] }} variant="h6" fontSize={18} textTransform="capitalize">
										{row.toLowerCase().split("_")?.join(" ")}
									</Typography>,
								);
							return acc;
						}, [])
						.map((row) => row)}
					<Typography sx={{ color: "text.primary" }} variant="h6" fontSize={18} textTransform="capitalize">
						{service.name}
					</Typography>
				</Breadcrumbs>
				{/* <Typography variant="h5">{service?.name}</Typography> */}
			</Box>

			<Box width="100%" sx={{ height: "calc(100% - 48px)", overflow: "hidden", display: "block" }}>
				{tabComponents?.[currentPath]?.component || (
					<Box sx={{ width: "100%", height: "100%" }}>
						<Typography variant="h6" sx={{ fontSize: "16px" }}>
							Restricted Access
						</Typography>
						<Typography sx={{ fontSize: "14px" }}>
							You currently don’t have permission to view this content. Please contact administrator.
						</Typography>
					</Box>
				)}
			</Box>
		</Box>
	);
};

export default StoreRecommendation;
